export const locale = {
    lang: 'de',
    data: {
        'NAV': {
            'APPLICATIONS': 'Anwendungen',
            'CONFIG': 'Einstellungen',
            'TOOLS': {
              'TITULO': 'Werkzeuge',
              'CHAT': 'Chat',
              'TODO': 'To-Do-Liste',
              'BROKER': 'Konfiguration durch Broker',
              'CHANGELOG': 'Änderungsprotokoll',
              'KNOWLEDGE': 'Wissensbasis',
              'WEB_COM_PROF':'Web-Firmenprofil',
            },
            'RESULTS': {
              'TITULO': 'Ergebnisse',

              'ENLACES': {
                'TI': 'Berichte',
                'TI_ESPANA': 'Online-Berichte',
                'COVID': 'COVID Umfrageergebnisse'
              },
              'ENLACES5': {
                'TI': 'Ergebnisse 5.0',
                'COVID': 'Covid survey resullts'
              },
              'ENLACES_ACTION_GO':{
                'TITULO':'ActionGo',
                // 'TITULO':'Aktionsplan - Führungskräfte',
              },
              'ENLACES_GO_FLOW':{
                'TITULO':'Go Flow Ergebnisse',
              }
            },
            'ACADEMY' : {
                'TITULO': 'Test Academy',
                'BADGE': '69'
            },
            'CERTIFICAR' : {
                'TITULO': 'Zertifizieren',
                'TITULOIZZI': 'Izzi',
                'TITULO_ESPAIN': 'Diagnose',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Zertifizieren',
                  '1': 'Certify 2.0',
                  '2': 'Izzi',
                  '3': 'Certify 3.0',
                  '4': 'Silber bescheinigen',
                  'SPA': 'Umfrage konfigurieren'
                }
            },
            'CERTIFICARN35' : {
                'TITULO': 'N35 zertifizieren',
                'BADGE': '69'
            },
            'MEDIR' : {
                'TITULO': 'Messung',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Messung',
                  '1': 'Messung erweitert',
                  '2': 'Messung + MST',
                  '3': 'Messung nach Bereichen',
                  '4': 'Messung nach Leitern',
                  '5': 'Messen nach Dimensionen',
                  '6': 'Messung zum Zertifizieren',
                  '7': 'Measurement 3.0',
                }
            },
            'PULSE' : {
                'TITULO': 'Pulse Check',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Pulse Check',
                  '1': 'Pulse Check 3.0',
                }
            },
            'FOCUS' : {
                'TITULO': 'Fokusbereich',
                'BADGE': '69'
            },
            'ENCUESTAS' : {
                'TITULO': 'Zusätzliche Zertifizierungen',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'AMCO',
                  '1': 'Anständige Arbeit',
                  '2': 'Erste Arbeit',
                }
            },
            'NORMA35': {
                'TITULO': 'Norm 035'
            },
            'NOM35BETHE': {
                'TITULO': 'Norm 035 better'
            },
            'NOM35PLA': {
                'TITULO': 'Norm 035 silver'
            },
            'NOM35V3': {
                'TITULO': 'Norm 035 3.0'
            },
            'LANGUAJE' : {
                'TITULO': 'Test languaje',
                'BADGE': '69'
            },
            'LOGIN' : {
                'TITULO': 'Test login',
                'BADGE': '69'
            },
            'PROFILECREATOR' : {
                'TITULO': 'Profilersteller',
                'BADGE': '69'
            },
            'PROFILELIST' : {
                'TITULO': 'Firmeninformationen',
                'BADGE': '69'
            },
            'NOPRODUCTOS' : {
                'TITULO': 'Sie haben keine Produkte',
                'BADGE': '69'
            },
            'RESPTI': {
              'TITULO': 'IT-Manager'
            },
            'REQTEC': {
              'TITULO': 'Technische Anforderungen'
            },
            'CLOUD': {
              'TITULO': 'Dateimanager',
              'TITULO_ESPANA': 'Bericht Downloads',
            },
            //Kultur-Audit
            'KULTUR': {
              'TITULO': 'Kultur Audit'
            },
            //Kultur Audit2
            'KULTUR2': {
              'TITULO': 'Kultur Audit 5.0'
            },
            //Kultur-Audit-Schulung
            'CATR': {
              'TITULO': 'Culture Audit Schulung'
            },
            //Feedback
            'FEEDBACK': {
              'TITULO': 'Feedback'
            },
            //Acercade
            'ABOUT': {
              'TITULO':'Changelog'
            },
            'QUESTIONS': {
              'TITULO':'Häufigste Fragen'
            },
            'VIDEOS': {
              'TITULO':'Anleitungsvideos'
            },
            'CONSULTAR_E': {
              'TITULO':'Consult Umfragen'
            },
            'CALEND_SUR': {
              'TITULO':'Umfrage-Kalender'
            },
            'VIDEOSADMIN': {
              'TITULO':'Administrator-Video'
            },
            'AUDITORIA-AUTO': {
              'TITULO':'Automated audit'
            },'LOG_SISTEMA': {
              'TITULO':'System Log'
            },'TIPPS': {
              'TITULO':'Norma tips'
            },'ENCUESTA': {
              'TITULO':'Colaboradores nuevos'
            },'CULTURETURQUIA1': {
              'TITULO': 'Culture Brief ve Culture Audit 5.0'
            },'CULTURETURQUIA2': {
              'TITULO': 'Culture Brief 5.0'
            },'CULTURETURQUIA3': {
              'TITULO': 'Kultur Audit 5.0'
            },

            'CULTUREMX1': {
            'TITULO': 'Kultur Audit 5.0'
            },'CULTUREMX2': {
              'TITULO': 'Kultur Audit Costa Rica'
            },'CULTUREMX3': {
              'TITULO': 'Kulturaudit GoFlow'
            },'CULTUREMX4': {
              'TITULO': 'Kultur Audit 5.0 Panama'
            },'CULTUREMX5': {
              'TITULO': 'Culture Audit 5.0 Strategische Partner'
            },
            'CULTUREMX11': {
              'TITULO': 'SP 2022'
            },
            'CULTUREMX12': {
              'TITULO': 'Kulturaudit GoFlow 2-2022'
            },
            'CULTUREMX13': {
              'TITULO': 'Kulturaudit Standard 1',
            },
            'CULTUREMX14': {
              'TITULO': 'Kultur Audit® CA&C'
            },
            'CULTURECH1': {
              'TITULO': 'Kultur Audit'
            },'CULTURECH2': {
              'TITULO': 'Kultur Audit 5.0'
            },'CULTURECH3': {
              'TITULO': 'Kultur Audit SP'
            },

            'CULTUREESP1':{
              'TITULO': 'Kultur Audit'
            },
            'CULTUREESP2':{
              'TITULO': 'Kultur Audit 5.0'
            },
            'CULTUREESP3':{
              'TITULO': 'Aktionsplan'
            },
            'CULTUREBRI':{
              'TITULO': 'Kultur Brief',
              'Culture Brief': 'Kultur Brief',
            },
            'CULTUREAUDI':{
              'TITULO': 'Kultur-Audit',
              'Culture Audit': 'Kultur-Audit',
            },
            'CONTACTO':{
              'TITULO': 'Kontakt'
            },
            'ACTIONGOADMIN':{
              'TITULO': 'Aktion GO® Verwalter'
            },
            'ACTIONGO':{
              'TITULO': 'Aktion GO®'
            },
            'LEADERGOADMIN':{
              'TITULO': 'Anführer GO® Verwalter',
            },
            'LEADERGOUSER':{
              'TITULO': 'Anführer GO®',
            },
            'medir_INNO':{
              'TITULO': 'Innmotion Umfrage',
            },
            'CULTURE_OZEL':{
              'TITULO': 'Besondere Liste',
            },
            'Culture_Ozel_TR1':{
              'TITULO': 'Soziale Verantwortung und Freiwilligentätigkeit',
            },
            'CONTROL_SURVE':{
              'TITULO': 'Kontrolle der Umfrage',
            },
            'CONSUL_REQUE':{
              'TITULO': 'Anforderungen konsultieren',
            },
            'SURVEY_GENERIC':{
              'TITULO': 'Allgemeiner Umfragebericht',
            },




        }
    }
};
